var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Clear",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C9.3137085,-6.08718376e-16 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 C2.6862915,12 4.05812251e-16,9.3137085 0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z M3.87868681,3.17157413 L3.17158003,3.87868091 C2.97822692,4.07203402 2.97823071,4.39243837 3.17158003,4.58578769 L4.58579359,6.00000125 L3.17158003,7.41421481 C2.97822481,7.60757003 2.97823282,7.92797438 3.17158003,8.1213216 L3.87868681,8.82842838 C4.07203992,9.02178149 4.39243837,9.0217836 4.58579359,8.82842838 L6.00000715,7.41421481 L7.41422071,8.82842838 C7.60757593,9.0217836 7.92797438,9.02178149 8.1213275,8.82842838 L8.82843428,8.1213216 C9.02178149,7.92797438 9.0217895,7.60757003 8.82843428,7.41421481 L7.41422071,6.00000125 L8.82843428,4.58578769 C9.0217836,4.39243837 9.02178739,4.07203402 8.82843428,3.87868091 L8.1213275,3.17157413 C7.92798028,2.97822692 7.60757003,2.97822481 7.41422071,3.17157413 L6.00000715,4.58578769 L4.58579359,3.17157413 C4.39244427,2.97822481 4.07203402,2.97822692 3.87868681,3.17157413 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundClose);
export default __webpack_public_path__ + "static/media/round-close.f42aaa7800f890da03e8b6f10041ff10.svg";
export { ForwardRef as ReactComponent };